import { render, staticRenderFns } from "./PreviewAndPost.vue?vue&type=template&id=71146dc5&scoped=true&"
import script from "./PreviewAndPost.vue?vue&type=script&lang=js&"
export * from "./PreviewAndPost.vue?vue&type=script&lang=js&"
import style0 from "./PreviewAndPost.vue?vue&type=style&index=0&id=71146dc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71146dc5",
  null
  
)

export default component.exports